<template>
    <div class="spinner-wrapper">
      <font-awesome-icon
        class="loading-spinner fa-spin fa-3x"
        :icon="['fad', 'circle-notch']"
      />
    </div>
</template>

<script>
export default {
  name: 'spinner',
}
</script>
<style lang="scss">
  @import '@/assets/scss/custom/components/variables';

  .spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: white;
    opacity: 0.9;

    .loading-spinner {
      --fa-primary-color: #{$secondary};
      --fa-secondary-color: #8b8b8b;
      --fa-secondary-opacity: 1.0;
    }
  }
</style>
